import { render, staticRenderFns } from "./CounterApplication.vue?vue&type=template&id=212e2288"
import script from "./CounterApplication.vue?vue&type=script&lang=ts"
export * from "./CounterApplication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports